// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1kjs-","errorLogs":"EditorFooter_errorLogs__Q9Deq"};